import { StyledFooterSection } from "./styles";
import { ROUTES } from "../../../constant/routes";
import BookDemoModal from "../../../components/shared/BookDemoModal";

const FooterSection = () => {
  return (
    <StyledFooterSection>
      <section className="cta">
        <div>
          <h2>
            Ready to bring every customer relationship into one workspace?
          </h2>

          <p>
            Messaging, collaboration, meetings, tasks, documents and AI  all in
            one place.
          </p>
        </div>

        <div className="hero-actions">
          <a
            className="btn"
            style={{
              background: "#fff",
              color: "#5d3f91",
            }}
            href={ROUTES.SIGNUP}
            target="_blank"
            rel="noopener noreferrer"
          >
            Start free
          </a>
          <BookDemoModal>
            <a
              className="btn btn-secondary"
              href="mailto:hello@kelu.uk?subject=Kelu%20demo%20request"
            >
              Book a demo
            </a>
          </BookDemoModal>
        </div>
      </section>
      <div className="section-padding">
        <footer className="">
          <div className="footer-container">
            <div className="footer-section">
              <h4>Product</h4>
              <ul className="footer-links">
                <li>
                  <a href="#features">Features</a>
                </li>
                <li>
                  <a href="#pricing">Pricing</a>
                </li>
                <li>
                  <a href="#ai_features">AI Features</a>
                </li>
                <li>
                  <a href="#how_it_works">How It Works</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <ul className="footer-links">
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Legal</h4>
              <ul className="footer-links">
                <li>
                  <a href={ROUTES.PRIVACY_POLICY}>Privacy Policy</a>
                </li>
                <li>
                  <a href={ROUTES.TERMS}>Terms of Service</a>
                </li>
                <li>
                  <a href={ROUTES.GDPR_POLICY}>GDPR</a>
                </li>
                <li>
                  <a href={ROUTES.COMPLIANCE}>Compliance</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>
              &copy; 2026 Kelu. Professional messaging that your customers will
              actually use.
            </p>
          </div>
        </footer>
      </div>
    </StyledFooterSection>
  );
};

export default FooterSection;
